import { Modal, PageHeader, Popconfirm, Space, Tag, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {
  TableItemDinamico,
  dineroDisabledMask,
  ButtonItem,
  SegmentedItem,
  NotificacionMovimientosInventario,
} from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import {
  BookOutlined,
  CloseCircleOutlined,
  EditOutlined,
  EyeOutlined,
  DownloadOutlined,
  SendOutlined,
  InboxOutlined,
  ReconciliationOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  LockOutlined,
  UnorderedListOutlined,
  // EnvironmentOutlined,
} from "@ant-design/icons";
import { IconArrowsSplit2 } from "../../../Icons/Icons";
import FacturasOrdenDeCompra from "./FacturasOrdenDeCompra/FacturasOrdenDeCompra";
import RecepcionesOrdenDeCompra from "./RecepcionesOrdenDeCompra/RecepcionesOrdenDeCompra";
import MandarCorreoOrdenDeCompra from "./MandarCorreoOrdenDeCompra/MandarCorreoOrdenDeCompra";
import ModalRutaAlmacenaje from "../../../Components/ModalRutaAlmacenaje";
import ModalUbicacionesConfirmadas from "../../../Components/ModalUbicacionesConfirmadas";
import ModalDescargarDocumentos from "../../../Components/ModalDescargarDocumentos";
import descargarDocumentosMasivo, { MODULOS } from "../../../Components/DescargarDocumentosMasivo";
import { PERMISOS_AUTORIZABLES } from "../../../Utils/autorizaciones";
import { montoMaximoPermiso } from "../../../Utils/permisos.utils";

moment.locale("es");


class OrdenesDeCompras extends Component {
  tableRef = null;
  state = {
    loading: false,
    modalCorreo: false,
    modalCorreoId: null,
    todasOrdenesDeCompra: [],
    modalFacturas: false,
    modalFacturasId: null,
    modalFacturasEstado: null,
    modalRecepciones: false,
    modalRecepcionesId: null,
    modalCancelarOC: false,
    modalCancelarOCId: null,
    valor: 5,
    ordenesSeleccionadas: [],
    objetoOrdenesDeCompraEncontradas: [],
    autorizacionesPendientesOC: {}, // {[ordenId]: true} mientras se resuelve la solicitud automática
    ordenDeCompraIdsConPendiente: new Set(), // ids con recepciones sin confirmar ubicación (botón "Ruta de almacenaje")
    modalRutaAlmacenajeVisible: false,
    modalRutaAlmacenajeOrdenId: null,
    modalUbicacionesConfirmadasVisible: false,
    modalUbicacionesConfirmadasOrdenId: null,
    usarColoresPendientesOC: false,
    rangosPendientesOCLeyenda: [],
    // `ids` son los seleccionados que sí se pueden descargar; puede ser un
    // subconjunto de `ordenesSeleccionadas` (se omiten las no aprobadas).
    modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 }, ids: [] },
  };

  /**
   * Una orden sin aprobar solo la puede bajar quien tiene el permiso de aprobar
   * (es quien la va a revisar). Misma regla que `puedeVistaPrevia` en la columna
   * de acciones. `aprobada` ausente = orden vieja, cuenta como aprobada.
   */
  ordenDescargable(ordenDeCompra) {
    if (this.props.permisoAprobarOrdenDeCompra) return true;
    return ordenDeCompra?.aprobada !== false;
  }

  /**
   * Parte la selección en lo que sí se puede bajar y cuántas se omiten.
   * `objetoOrdenesDeCompraEncontradas` acumula el registro completo de cada
   * orden que se seleccionó (incluye `aprobada`); `todasOrdenesDeCompra` cubre
   * la página visible.
   */
  idsDescargables() {
    const registros = [
      ...this.state.objetoOrdenesDeCompraEncontradas,
      ...this.state.todasOrdenesDeCompra,
    ];
    const ids = this.state.ordenesSeleccionadas.filter((ordenId) => {
      const ordenDeCompra = registros.find((c) => c._id?.toString() === ordenId);
      // Sin el registro a la mano no se puede saber si está aprobada: se omite.
      if (!ordenDeCompra) return false;
      return this.ordenDescargable(ordenDeCompra);
    });
    return { ids, omitidas: this.state.ordenesSeleccionadas.length - ids.length };
  }

  abrirDescarga() {
    const { ids, omitidas } = this.idsDescargables();

    if (ids.length === 0) {
      return message.warn("No puedes descargar ordenes de compra sin aprobar");
    }

    if (omitidas > 0) {
      message.warn(
        omitidas === 1
          ? "Se omitio 1 orden no aprobada"
          : `Se omitieron ${omitidas} ordenes no aprobadas`
      );
    }

    this.setState({ modalDescarga: { visible: true, loading: false, progreso: { hechos: 0, total: 0 }, ids } });
  }

  cerrarDescarga() {
    this.setState({ modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 }, ids: [] } });
  }

  async confirmarDescarga(formatos) {
    // Se copia antes: `cerrarDescarga()` al final vacía `modalDescarga.ids`.
    const ids = this.state.modalDescarga.ids;
    this.setState((prev) => ({ modalDescarga: { ...prev.modalDescarga, loading: true } }));
    const descargo = await descargarDocumentosMasivo({
      modulo: "ordenDeCompra",
      ids,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      ...formatos,
      onProgreso: (hechos, total) => this.setState((prev) => ({
        modalDescarga: { ...prev.modalDescarga, progreso: { hechos, total } },
      })),
    });
    this.cerrarDescarga();
    // Bajar el PDF marca las órdenes como descargadas: hay que refrescar para
    // que el listado muestre el Tag.
    if (descargo && formatos.incluirPdf && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }

  componentDidMount() {
    //this.consultarOrdenesDeCompra(this.state.valor);
    window.addEventListener("autorizacion_refresh", this.onAutorizacionRefreshOC);
    window.addEventListener("autorizacion_update", this.onAutorizacionRefreshOC);
    this.consultarConfiguracionOrdenesDeCompra();
  }

  async consultarConfiguracionOrdenesDeCompra() {
    axios
      .post(
        "configuracionOrdenesDeCompra/selectConfiguracionOrdenesDeCompra",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            usarColoresPendientesOC: res.data.usarColoresPendientesOC,
            rangosPendientesOCLeyenda: res.data.rangosPendientesOC || [],
          });
        }
      });
  }

  getIndiceRangoPendiente(record) {
    if (!this.state.usarColoresPendientesOC || this.state.rangosPendientesOCLeyenda.length === 0) {
      return null;
    }

    if (record.estado !== 1 && record.estado !== 2) {
      return null;
    }

    const diasAntiguedad = moment().diff(moment(record.createdAt), 'days');
    const rangosOrdenados = [...this.state.rangosPendientesOCLeyenda].sort((a, b) => a.tope - b.tope);

    for (let i = 0; i < rangosOrdenados.length; i++) {
      if (diasAntiguedad <= rangosOrdenados[i].tope) {
        return i;
      }
    }

    // Ya pasó el tope más alto configurado: se queda en el último nivel (el más grave)
    return rangosOrdenados.length - 1;
  }

  componentWillUnmount() {
    window.removeEventListener("autorizacion_refresh", this.onAutorizacionRefreshOC);
    window.removeEventListener("autorizacion_update", this.onAutorizacionRefreshOC);
  }

  abrirMandarCorreoOrdenDeCompra(id) {
    this.setState({
      modalCorreo: true,
      modalCorreoId: id,
    });
  }

  cerrarMandarCorreoOrdenDeCompra() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }

  consultarOrdenesDeCompra(params = {}) {
    this.setState({ loading: true });

    const body = {
      empresaId : this.props.empresaId,
      ...params
    }; 


    axios
      .post(
        "ordenesdecompra/selectOrdenesDeCompra",
        body,
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ todasOrdenesDeCompra: [], totalRecords: 0, loading: false });
        } else {
          const data = res.data.data;
          let total = res.data.totalRecords;
          this.setState({
            loading: false,
            totalRecords: total,
            todasOrdenesDeCompra: data.map((value) => {
              return {
                ...value,
                proveedorNombre: value.proveedorNombre ? value.proveedorNombre : (value.proveedor.nombre
                  ? value.proveedor.nombre +
                  " " +
                  value.proveedor.apellidoPaterno +
                  " " +
                  value.proveedor.apellidoMaterno
                  : value.proveedor.razonSocial),
                accion: {
                  _id: value._id,
                  estado: value.estado,
                  xml: value.xml,
                  estadoFactura: value.estadoFactura,
                  requisicionNumero: value.requisicionNumero,
                  requisicionesExtras: value.requisicionesExtras,
                  finiquitada: value.finiquitada,
                  aprobada: value.aprobada,
                },
              };
            }),
          });
          this.consultarRutaAlmacenajePendiente(data.map((value) => value._id));
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({ loading: false, todasOrdenesDeCompra: [], totalRecords: 0 });
      })
  }

  consultarRutaAlmacenajePendiente(ordenDeCompraIds) {
    if (!Array.isArray(ordenDeCompraIds) || ordenDeCompraIds.length === 0) {
      this.setState({ ordenDeCompraIdsConPendiente: new Set() });
      return;
    }
    axios
      .post(
        "ordenesdecompra/ordenesConRutaAlmacenajePendiente",
        { empresaId: this.props.empresaId, ordenDeCompraIds },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ ordenDeCompraIdsConPendiente: new Set(res.data.ordenDeCompraIdsConPendiente) });
        }
      })
      .catch((err) => console.error("Error al consultar rutas de almacenaje pendientes:", err));
  }

  agregarOrdenDeCompra() {
    this.props.history.push("/panel/agregarOrdenDeCompra");
  }
  recibirInsumosOrden(id) {
    this.props.history.push("/panel/recibirInsumosOrdenDeCompra", { id });
  }
  cerrarModalRutaAlmacenaje() {
    this.setState({ modalRutaAlmacenajeVisible: false, modalRutaAlmacenajeOrdenId: null });
    this.consultarRutaAlmacenajePendiente(this.state.todasOrdenesDeCompra.map((value) => value._id));
  }
  recibirFacturaOrden(id) {
    this.props.history.push("/panel/recibirFacturaOrdenDeCompra", { id });
  }
  editarOrdenDeCompra(id) {
    this.props.history.push("/panel/editarOrdenDeCompra", { id });
  }
  irAInsumosPendientes() {
    this.props.history.push("/panel/insumosPendientesOrdenDeCompra");
  }
  descargarXml(value) {
    axios
      .post(
        "ordenesdecompra/descargarXml",
        { ordenDeCompraId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        var xmltext = res.data.string;

        var filename = "file.xml";
        var pom = document.createElement("a");
        var bb = new Blob([xmltext], { type: "text/plain" });

        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);

        pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(
          ":"
        );
        pom.draggable = true;
        pom.classList.add("dragout");

        pom.click();
      });
  }

  aprobarOrdenDeCompra(record) {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesdecompra/aprobarOrden",
        { ordenId: record._id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Orden de compra aprobada");
        } else if (res.data.success === 1) {
          message.info(res.data.message);
        } else {
          message.error(
            res.data.message || "Sucedio un error y no se pudo aprobar"
          );
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (this.props.autorizacionesRapidas && error?.response?.data?.codigo === "AUTORIZACION_REQUERIDA") {
          this.solicitarAutorizacionAutomaticaOC(record);
        } else {
          message.error(
            error?.response?.data?.message || "No se pudo aprobar la orden"
          );
        }
      });
  }

  solicitarAutorizacionAutomaticaOC = async (record) => {
    const monto = record.total ?? record.totalPagar ?? 0;
    this.setState({
      autorizacionesPendientesOC: { ...this.state.autorizacionesPendientesOC, [record._id]: true },
    });
    try {
      const res = await axios.post(
        "/autorizaciones/crearSolicitud",
        {
          empresaId: this.props.empresaId,
          permisoId: PERMISOS_AUTORIZABLES.aprobarOrdenCompra.permisoId,
          contexto: {
            modulo: "ORDEN_COMPRA",
            campo: "aprobarOrdenCompra",
            documentoId: record._id,
            folio: String(record.numero ?? ""),
            monto,
            descripcion: `Aprobar orden de compra ${record.numero ?? ""} por ${dineroDisabledMask(monto)}`,
          },
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.info(
          "No tienes permiso para aprobar esta orden: se envió una solicitud a los autorizadores configurados."
        );
      }
    } catch (error) {
      this.setState((prev) => {
        const autorizacionesPendientesOC = { ...prev.autorizacionesPendientesOC };
        delete autorizacionesPendientesOC[record._id];
        return { autorizacionesPendientesOC };
      });
      message.error(
        error?.response?.data?.mensaje || "No se pudo enviar la solicitud de autorización"
      );
    }
  };

  onAutorizacionRefreshOC = () => {
    this.setState({ autorizacionesPendientesOC: {} });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  };

  cancelarOrdenDeCompra(value, regresarInsumos) {
    this.setState({ loading: true, modalCancelarOC: false, modalCancelarOCId: null });
    axios
      .post(
        "ordenesdecompra/cancelarOrden",
        { ordenId: value, empresaId: this.props.empresaId, regresarInsumos },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Orden de compra cancelada");
          NotificacionMovimientosInventario(res.data.movimientosIds);
        } else {
          message.error(
            res.data.message || "Sucedio un error y no se pudo cancelar"
          );
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  abrirModalCancelarOC(id) {
    this.setState({ modalCancelarOC: true, modalCancelarOCId: id });
  }

  cerrarModalCancelarOC() {
    this.setState({ modalCancelarOC: false, modalCancelarOCId: null });
  }

  cerrarFacturasOrdenDeCompra() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    this.setState({ modalFacturas: false, modalFacturasId: null, modalFacturasEstado: null });
  }

  cerrarRecepcionesOrdenDeCompra() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    this.setState({ modalRecepciones: false, modalRecepcionesId: null });
  }

  finiquitarOrdenDeCompra(id) {
    axios
      .post(
        "ordenesdecompra/finiquitarOrden",
        { ordenId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Orden de compra finiquitada");
        } else {
          message.error(
            res.data.message || "Sucedio un error y no se pudo finiquitar"
          );
        }
        this.consultarOrdenesDeCompra(this.state.valor);
      });
  }

  // La selección es libre: cualquier orden se puede marcar, porque también
  // alimenta la descarga masiva. Las reglas de mismo proveedor, misma moneda y
  // estado de factura se validan al usar Agrupar Ordenes o Recibir Factura.
  onSelectChange = (ordenesSeleccionadas) => {
    let encontrarOrdenes = [];

    for (const ordenId of ordenesSeleccionadas) {
      const yaGuardada = this.state.objetoOrdenesDeCompraEncontradas.find(
        (c) => c._id?.toString() === ordenId
      );
      if (yaGuardada) continue;
      const ordenDeCompra = this.state.todasOrdenesDeCompra.find(
        (c) => c._id?.toString() === ordenId
      );
      if (ordenDeCompra) encontrarOrdenes.push(ordenDeCompra);
    }

    this.setState({
      ordenesSeleccionadas,
      objetoOrdenesDeCompraEncontradas: [
        ...this.state.objetoOrdenesDeCompraEncontradas,
        ...encontrarOrdenes,
      ],
    });
  };

  /**
   * Valida la selección para las acciones que sí exigen órdenes homogéneas
   * (agrupar y recibir factura): mismo proveedor, misma moneda y sin factura
   * completa. Devuelve false si alguna no aplica; ya se avisó al usuario.
   */
  ordenesHomogeneasSeleccionadas() {
    const { ordenesSeleccionadas } = this.state;
    if (ordenesSeleccionadas.length === 0) {
      message.warn("No hay ordenes de compra seleccionadas");
      return false;
    }

    let proveedorId = null;
    let monedaId = null;

    for (const ordenId of ordenesSeleccionadas) {
      let ordenDeCompra = this.state.todasOrdenesDeCompra.find(
        (c) => c._id?.toString() === ordenId
      );
      if (!ordenDeCompra) {
        ordenDeCompra = this.state.objetoOrdenesDeCompraEncontradas.find(
          (c) => c._id?.toString() === ordenId
        );
      }
      if (!ordenDeCompra) {
        message.warn("No se encontró la orden de compra seleccionada");
        return false;
      }

      if (ordenDeCompra.estadoFactura !== 0 && ordenDeCompra.estadoFactura !== 2) {
        message.warn("Solo se pueden usar ordenes de compra sin factura o facturadas parcialmente");
        return false;
      }

      if (!proveedorId) {
        proveedorId = ordenDeCompra.proveedorId?.toString();
      } else if (proveedorId !== ordenDeCompra.proveedorId?.toString()) {
        message.warn("Las ordenes de compra seleccionadas no pertenecen al mismo proveedor");
        return false;
      }

      if (!monedaId) {
        monedaId = ordenDeCompra.monedaId?.toString();
      } else if (monedaId !== ordenDeCompra.monedaId?.toString()) {
        message.warn("Las ordenes de compra seleccionadas no tienen la misma moneda");
        return false;
      }
    }

    return true;
  }

  recibirFacturaOrdenesSeleccionadas() {
    const { ordenesSeleccionadas } = this.state;
    if (ordenesSeleccionadas.length < 2) {
      return message.warn("Selecciona al menos dos ordenes de compra");
    }
    if (!this.ordenesHomogeneasSeleccionadas()) return;
    this.props.history.push("/panel/recibirFacturaOrdenesDeCompra", {
      ids: ordenesSeleccionadas,
    });
  }

  agruparOrdenesDeCompra() {
    const { ordenesSeleccionadas } = this.state;
    if (!this.ordenesHomogeneasSeleccionadas()) return;
    this.setState({ loading: true });

    axios
      .post(
        "ordenesdecompra/agruparOrdenes",
        {
          ordenesSeleccionadas: ordenesSeleccionadas,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se agrego la orden de compra " + res.data.codigo);
          this.setState({ ordenesSeleccionadas: [] });
        } else if (res.data.success === 1) {
          message.warning(
            res.data.message ? res.data.message : "Hubo un error"
          );
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        this.consultarOrdenesDeCompra(this.state.valor);
      });
  }

  render() {
    const { totalRecords, todasOrdenesDeCompra, loading, ordenesSeleccionadas, usarColoresPendientesOC, rangosPendientesOCLeyenda } = this.state;

    const coloresFijosPendientesOC = [
      'rgba(236, 251, 241, 1)',
      'rgba(223, 247, 230, 1)',
      'rgba(255, 244, 204, 1)',
      'rgba(255, 226, 204, 1)',
      'rgba(255, 214, 214, 1)',
    ];

    const rangosPendientesOCOrdenados = usarColoresPendientesOC
      ? [...rangosPendientesOCLeyenda].sort((a, b) => a.tope - b.tope)
      : [];

    const estadosLeyendaPendientesOC = usarColoresPendientesOC
      ? rangosPendientesOCOrdenados.map((rango, index) => ({
        color: rango.color || coloresFijosPendientesOC[index] || 'rgba(200, 200, 200, 1)',
        label: rango.nombre,
        key: `pendiente-oc-${index}`,
        tope: rango.tope,
      }))
      : [];

    const cssFilasPendientesOC = usarColoresPendientesOC
      ? rangosPendientesOCOrdenados
        .map((rango, index) => {
          const color = rango.color || coloresFijosPendientesOC[index] || 'rgba(200, 200, 200, 1)';
          return `
                .fila-pendiente-oc-${index} > td {
                    background-color: ${color} !important;
                }

                .fila-pendiente-oc-${index}:hover > td {
                    background-color: ${color} !important;
                }
            `;
        })
        .join("\n")
      : "";

    const columns = [
      {
        title: "Num.",
        dataIndex: "numero",
        key: "numero",
        sorter: (a, b) => {
          if (a.numero < b.numero) {
            return -1;
          }
          if (a.numero > b.numero) {
            return 1;
          }
          return 0;
        },
        width: "7%",
        buscar: "numero",
        ellipsis: true,
      },
      {
        title: "Req.",
        dataIndex: "requisicionNumero",
        key: "requisicionNumero",
        sorter: (a, b) => {
          if (a.requisicionNumero < b.requisicionNumero) {
            return -1;
          }
          if (a.requisicionNumero > b.requisicionNumero) {
            return 1;
          }
          return 0;
        },
        width: "7%",
        buscar: "requisicionNumero",
        align: "center",
        ellipsis: true,
      },
      {
        title: "Presupuesto PU",
        dataIndex: "presupuestoPUNombre",
        key: "presupuestoPUNombre",
        sorter: (a, b) => {
          if ((a.presupuestoPUNombre || "") < (b.presupuestoPUNombre || "")) {
            return -1;
          }
          if ((a.presupuestoPUNombre || "") > (b.presupuestoPUNombre || "")) {
            return 1;
          }
          return 0;
        },
        render: (value) => value || "—",
        width: "10%",
        buscar: "presupuestoPU",
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: "13%",
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        sorter: (a, b) => {
          if (a.proveedorNombre < b.proveedorNombre) {
            return -1;
          }
          if (a.proveedorNombre > b.proveedorNombre) {
            return 1;
          }
          return 0;
        },
        buscar: 'proveedorNombre',
        width: "15%",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("L"),
        width: "12%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Fecha De Entrega",
        dataIndex: "fechaEntrega",
        key: "fechaEntrega",
        sorter: (a, b) => {
          if (moment(a.fechaEntrega) < moment(b.fechaEntrega)) {
            return -1;
          }
          if (moment(a.fechaEntrega) > moment(b.fechaEntrega)) {
            return 1;
          }
          return 0;
        },
        render: (value) => value ? moment(value).locale("es").format("L") : " - ",
        width: "12%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.moneda}</span>}
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.totalPagar)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
            </div>
          </div>
        ),
        buscar: "totalPagar",
        width: "15%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        width: 0,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (value, record) => {
          let estadoTags = [];
          let iconos = [];

          if (record.finiquitada) {
            estadoTags.push(<Tag color="purple" className="square-tag">Finiquitada</Tag>);
          }
          if (record.aprobada === false && value !== 0) {
            estadoTags.push(<Tag color="gold" className="square-tag">Por aprobar</Tag>);
          }
          if (value === 0) {
            estadoTags.push(record.ordenAgrupadaId
              ? <Tag color="magenta" className="square-tag">Agrupada</Tag>
              : <Tag color="red" className="square-tag">Cancelada</Tag>);
          }
          if (value === 1) {
            estadoTags.push(<Tag color="blue" className="square-tag">Sin recibir</Tag>);
          }
          if (value === 2) {
            estadoTags.push(
              <Tag color="orange" className="square-tag" style={{ fontSize: 10 }}>
                Recibido parcialmente
              </Tag>
            );
          }
          if (value === 3) {
            estadoTags.push(<Tag color="green" className="square-tag">Recibido</Tag>);
          }

          // Icono 
          if (record.enviada) {
            iconos.push(
              <Tooltip title="Enviada" key="enviada" overlayInnerStyle={{ fontSize: '12px', padding: '1px 5px', minHeight: 'auto' }}>
                <Tag>
                  <SendOutlined />
                </Tag>
              </Tooltip>
            );
          }

          if (record.descargada) {
            iconos.push(
              <Tooltip title="Descargada" key="descargada" overlayInnerStyle={{ fontSize: '12px', padding: '1px 5px', minHeight: 'auto' }}>
                <Tag>
                  <DownloadOutlined />
                </Tag>
              </Tooltip>
            );
          }

          return (
            <Space direction="vertical" size={2}>
              {estadoTags}
              {iconos.length > 0 && (
                <Space size={4}>
                  {iconos}
                </Space>
              )}
            </Space>
          );
        },
        width: "13%",
        ellipsis: true,
      },

      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "25%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          let buttons = [];

          const cancelada = value.estado === 0;
          const aprobada = value.aprobada !== false;

          const puedeEditar = value.estado !== 3 && value.estadoFactura !== 3 && !cancelada && this.props.permisoEditarOrdenDeCompra;
          buttons.push(
            <Tooltip key={`edit-tip-${index}`} title={puedeEditar ? "Editar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`edit-${index}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => puedeEditar && this.editarOrdenDeCompra(value._id)}
                disabled={!puedeEditar}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeVistaPreviaBase = !cancelada;
          const puedeVistaPrevia = puedeVistaPreviaBase && (aprobada || this.props.permisoAprobarOrdenDeCompra);
          buttons.push(
            <Tooltip key={`eye-tip-${index}`} title={puedeVistaPrevia ? (aprobada ? "Ver orden" : "Ver para aprobar") : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`eye-${index}`}
                type="default"
                size="small"
                rosa
                icon={<EyeOutlined />}
                onClick={() => puedeVistaPrevia && this.abrirMandarCorreoOrdenDeCompra(value._id)}
                disabled={!puedeVistaPrevia}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (!aprobada && !cancelada) {
            // Tope por monto: si el permiso "Monto Aprobacion" tiene un valor,
            // solo puede aprobar ordenes cuyo total no lo supere (null = sin tope).
            const montoMax = this.props.montoMaximoAprobacion;
            const dentroDelMonto =
              montoMax == null || (record.totalPagar || 0) <= montoMax;
            const puedeAprobarPropio =
              this.props.permisoAprobarOrdenDeCompra && dentroDelMonto;
            const autorizacionesActivas = !!this.props.autorizacionesRapidas;
            const autorizacionPendienteOC = autorizacionesActivas && !!this.state.autorizacionesPendientesOC[value._id];

            // Con el complemento apagado: comportamiento original, sin
            // solicitudes automáticas — solo verde/deshabilitado.
            let tituloAprobar;
            let tituloConfirm = "Seguro que quieres aprobar esta orden de compra";
            let icono = <CheckCircleOutlined />;
            let disabledBtn = !puedeAprobarPropio;
            let esNaranja = false;

            if (!autorizacionesActivas) {
              tituloAprobar = puedeAprobarPropio
                ? "Aprobar"
                : !this.props.permisoAprobarOrdenDeCompra
                  ? "No tiene permiso para aprobar"
                  : `Supera tu monto máximo de aprobación (${dineroDisabledMask(montoMax)})`;
            } else if (autorizacionPendienteOC) {
              tituloAprobar = "Esperando que un autorizador apruebe esta orden…";
              icono = <LockOutlined />;
              disabledBtn = true;
            } else if (puedeAprobarPropio) {
              tituloAprobar = "Aprobar";
            } else {
              tituloAprobar = !this.props.permisoAprobarOrdenDeCompra
                ? "No tienes permiso para aprobar: se enviará una solicitud a tus autorizadores"
                : `Supera tu monto máximo de aprobación (${dineroDisabledMask(montoMax)}): se enviará una solicitud a tus autorizadores`;
              tituloConfirm = "No puedes aprobar esta orden. ¿Enviar la solicitud a tus autorizadores?";
              icono = <SendOutlined />;
              disabledBtn = false;
              esNaranja = true;
            }

            buttons.push(
              <Tooltip key={`aprobar-tip-${index}`} title={tituloAprobar} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <Popconfirm
                  key={`aprobar-${index}`}
                  title={tituloConfirm}
                  onConfirm={() => this.aprobarOrdenDeCompra(record)}
                  okText="Si"
                  cancelText="No"
                  disabled={disabledBtn}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    verde={!esNaranja}
                    naranja={esNaranja}
                    icon={icono}
                    disabled={disabledBtn}
                  >
                  </ButtonItem>
                </Popconfirm>
              </Tooltip>
            );
          }

          if (aprobada) {
            const puedeRecibirInsumos = (value.estado === 1 || value.estado === 2) && this.props.permisoRecibirInsumosOrdenDeCompra;
            buttons.push(
              <Tooltip key={`recibir-insumos-tip-${index}`} title={puedeRecibirInsumos ? "Recibir Insumos" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`recibir-insumos-${index}`}
                  type="default"
                  size="small"
                  azul
                  icon={<InboxOutlined />}
                  onClick={() => puedeRecibirInsumos && this.recibirInsumosOrden(value._id)}
                  disabled={!puedeRecibirInsumos}
                >
                </ButtonItem>
              </Tooltip>
            );

            // const tieneRutaAlmacenajePendiente = this.state.ordenDeCompraIdsConPendiente?.has(value._id.toString());
            // if (tieneRutaAlmacenajePendiente && this.props.permisoRecibirInsumosOrdenDeCompra && this.props.moduloWms) {
            //   buttons.push(
            //     <Tooltip key={`ruta-almacenaje-tip-${index}`} title="Ruta de almacenaje" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            //       <ButtonItem
            //         key={`ruta-almacenaje-${index}`}
            //         type="default"
            //         size="small"
            //         naranja
            //         icon={<EnvironmentOutlined />}
            //         onClick={() => this.setState({ modalRutaAlmacenajeOrdenId: value._id, modalRutaAlmacenajeVisible: true })}
            //       >
            //       </ButtonItem>
            //     </Tooltip>
            //   );
            // }

            // const yaRecibioAlgo = value.estado === 2 || value.estado === 3;
            // if (yaRecibioAlgo && this.props.permisoRecibirInsumosOrdenDeCompra && this.props.moduloWms) {
            //   buttons.push(
            //     <Tooltip key={`ver-ubicaciones-tip-${index}`} title="Ver ubicaciones" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            //       <ButtonItem
            //         key={`ver-ubicaciones-${index}`}
            //         type="default"
            //         size="small"
            //         turquesa
            //         icon={<EyeOutlined />}
            //         onClick={() => this.setState({ modalUbicacionesConfirmadasOrdenId: value._id, modalUbicacionesConfirmadasVisible: true })}
            //       >
            //       </ButtonItem>
            //     </Tooltip>
            //   );
            // }

            const puedeRecibirFactura = (value.estadoFactura === 0 || value.estadoFactura === 2) && this.props.permisoRecibirFacturaOrdenDeCompra && !cancelada;
            buttons.push(
              <Tooltip key={`recibir-factura-tip-${index}`} title={puedeRecibirFactura ? "Recibir Factura" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`recibir-factura-${index}`}
                  type="default"
                  size="small"
                  lima
                  icon={<ReconciliationOutlined />}
                  onClick={() => puedeRecibirFactura && this.recibirFacturaOrden(value._id)}
                  disabled={!puedeRecibirFactura}
                >
                </ButtonItem>
              </Tooltip>
            );

            const puedeDescargarXml = !cancelada && value.xml;
            buttons.push(
              <Tooltip key={`xml-tip-${index}`} title={puedeDescargarXml ? "Descargar XML" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`xml-${index}`}
                  type="default"
                  size="small"
                  blanco
                  icon={<FileTextOutlined />}
                  onClick={() => puedeDescargarXml && this.descargarXml(value._id)}
                  disabled={!puedeDescargarXml}
                >
                </ButtonItem>
              </Tooltip>
            );

            const puedeVerFacturas = value.estadoFactura !== 0 && !cancelada;
            buttons.push(
              <Tooltip key={`facturas-tip-${index}`} title={puedeVerFacturas ? "Ver Facturas de Orden" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`facturas-${index}`}
                  type="default"
                  size="small"
                  lila
                  icon={<BookOutlined />}
                  onClick={() => puedeVerFacturas && this.setState({ modalFacturas: true, modalFacturasId: value._id, modalFacturasEstado: value.estado })}
                  disabled={!puedeVerFacturas}
                >
                </ButtonItem>
              </Tooltip>
            );

            const puedeVerRecepciones = value.estado === 2 || value.estado === 3;
            buttons.push(
              <Tooltip key={`recepciones-tip-${index}`} title={puedeVerRecepciones ? "Ver Recepciones de Orden" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`recepciones-${index}`}
                  type="default"
                  size="small"
                  verde
                  icon={<UnorderedListOutlined />}
                  onClick={() => puedeVerRecepciones && this.setState({ modalRecepciones: true, modalRecepcionesId: value._id })}
                  disabled={!puedeVerRecepciones}
                >
                </ButtonItem>
              </Tooltip>
            );

            const puedeFiniquitar = value.estado === 2 && value.estadoFactura === 2;
            buttons.push(
              <Tooltip
                title={puedeFiniquitar ? "Finiquitar  O.C." : "No disponible"}
                placement="top"
                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                key={`finiquitar-tooltip-${index}`}
              >
                <Popconfirm
                  title="Seguro que quieres finiquitar esta orden de compra"
                  onConfirm={() => this.finiquitarOrdenDeCompra(value._id)}
                  okText="Si"
                  cancelText="No"
                  key={`finiquitar-popconfirm-${index}`}
                >
                  <ButtonItem
                    naranja
                    type="default"
                    size="small"
                    icon={<CheckCircleOutlined />}
                    disabled={!puedeFiniquitar}
                  >
                  </ButtonItem>
                </Popconfirm>
              </Tooltip>
            );

          if ((value.estado === 2 || value.estado === 3) && this.props.prorrateoDesCostos) {
            buttons.push(
              <Tooltip title="Prorrateo" key={`prorrateo-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  morado
                  icon={<IconArrowsSplit2 marginRight={0} />}
                  onClick={() => this.props.history.push('/panel/prorratearOrdenDeCompra', { id: value._id })}
                />
              </Tooltip>
            );
          }
          }

          const puedeCancelar = value.estadoFactura === 0 && !cancelada && this.props.permisoCancelarOrdenDeCompra;
          const tieneRequisicion = Boolean(value.requisicionNumero) || value.requisicionesExtras?.length > 0;
          const botonCancelar = (
            <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                rojo
                icon={<CloseCircleOutlined />}
                disabled={!puedeCancelar}
                onClick={tieneRequisicion ? () => puedeCancelar && this.abrirModalCancelarOC(value._id) : undefined}
              >
              </ButtonItem>
            </Tooltip>
          );
          buttons.push(
            tieneRequisicion ? (
              <React.Fragment key={`cancelar-${index}`}>{botonCancelar}</React.Fragment>
            ) : (
              <Popconfirm
                key={`cancelar-${index}`}
                title="Seguro que quieres cancelar esta orden de compra"
                onConfirm={() => this.cancelarOrdenDeCompra(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!puedeCancelar}
              >
                {botonCancelar}
              </Popconfirm>
            )
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <style>{cssFilasPendientesOC}</style>
        <PageHeader
          title="Ordenes de Compras"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Sin Recibir", value: 1 },
                    { label: "Recibido Parcialmente", value: 2 },
                    { label: "Recibido", value: 3 },
                    { label: "Todos", value: 5 },
                    { label: "Cancelado", value: 4 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              {this.props.permisoAgregarOrdenDeCompra && (
                <ButtonItem
                  type="primary"
                  olivo
                  key="agregarOrdenDeCompra"
                  onClick={this.agregarOrdenDeCompra.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Orden de Compra
                </ButtonItem>
              )}
              {this.props.permisoListadoDePendientes && (
                <ButtonItem
                  type="primary"
                  blanco
                  key="insumosPendientesOrdenDeCompra"
                  onClick={this.irAInsumosPendientes.bind(this)}
                >
                  Insumos Pendientes
                </ButtonItem>
              )}
              {this.state.ordenesSeleccionadas.length > 0 && (
                <ButtonItem
                  blanco
                  icon={<DownloadOutlined />}
                  key="descargarOrdenesDeCompra"
                  onClick={this.abrirDescarga.bind(this)}
                >
                  Descargar ({this.state.ordenesSeleccionadas.length})
                </ButtonItem>
              )}
              {this.state.ordenesSeleccionadas.length > 0 && (
                <Popconfirm
                  title={
                    "Seguro que quieres agrupar las ordenes de compra seleccionadas"
                  }
                  onConfirm={() => this.agruparOrdenesDeCompra()}
                >
                  <ButtonItem
                    type="primary"
                    blanco
                    key="agruparOrdenesDeCompra"
                  >
                    Agrupar Ordenes
                  </ButtonItem>
                </Popconfirm>
              )}
              {this.state.ordenesSeleccionadas.length > 1 &&
                this.props.permisoRecibirFacturaOrdenDeCompra && (
                  <ButtonItem
                    type="primary"
                    orange
                    key="recibirFacturaOrdenesSeleccionadas"
                    onClick={() => this.recibirFacturaOrdenesSeleccionadas()}
                  >
                    Recibir Factura
                  </ButtonItem>
                )}
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarOrdenesDeCompra.bind(this)}
          size="small"
          estadosLeyenda={[
            { color: '#FFCAF0', label: 'Agregado', key: 'agregado' },
            ...estadosLeyendaPendientesOC,
          ]}
          rowClassName={(record, index) => {
            const indiceRangoPendiente = this.getIndiceRangoPendiente(record);
            if (indiceRangoPendiente !== null) return `fila-pendiente-oc-${indiceRangoPendiente}`;
            return index % 2 === 0 ? 'zebra-gris' : 'default';
          }}
          dataSource={todasOrdenesDeCompra}
          columns={columns}
          pagination={false}
          // Selección de filas
          rowSelection={{
            selectedRowKeys: ordenesSeleccionadas,
            onChange: this.onSelectChange.bind(this),
            // La tabla pagina del lado del servidor: sin esto, antd tira las
            // llaves de las páginas anteriores al paginar.
            preserveSelectedRowKeys: true,
          }}

          // Doble click
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verOrdenDeCompra", {
                  id: record._id,
                });
              },
            };
          }}

          // Filtros
          filterStorageKey={"ordenesCompraFiltrosTabla" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })} 
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} //Este prop es para la bárra de búsqueda
          valorDefault={5}
          valorTextoDefault={""}
          locale={{ emptyText: "No se encontraron ordenes de compra" }}
        />

        <ModalDescargarDocumentos
          visible={this.state.modalDescarga.visible}
          loading={this.state.modalDescarga.loading}
          progreso={this.state.modalDescarga.progreso}
          total={this.state.modalDescarga.ids.length}
          tieneXml={MODULOS.ordenDeCompra.tieneXml}
          onClose={this.cerrarDescarga.bind(this)}
          onConfirm={this.confirmarDescarga.bind(this)}
        />

        <MandarCorreoOrdenDeCompra
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoOrdenDeCompra={this.cerrarMandarCorreoOrdenDeCompra.bind(
            this
          )}
        />
        <FacturasOrdenDeCompra
          history={this.props.history}
          visible={this.state.modalFacturas}
          id={this.state.modalFacturasId}
          estadoOrden={this.state.modalFacturasEstado}
          cerrarFacturasOrdenDeCompra={this.cerrarFacturasOrdenDeCompra.bind(
            this
          )}
        />
        <RecepcionesOrdenDeCompra
          visible={this.state.modalRecepciones}
          id={this.state.modalRecepcionesId}
          cerrarRecepcionesOrdenDeCompra={this.cerrarRecepcionesOrdenDeCompra.bind(
            this
          )}
        />
        <ModalRutaAlmacenaje
          visible={this.state.modalRutaAlmacenajeVisible}
          onClose={this.cerrarModalRutaAlmacenaje.bind(this)}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          documentoOrigenId={this.state.modalRutaAlmacenajeOrdenId}
          documentoOrigenTipo="OrdenDeCompra"
        />
        <ModalUbicacionesConfirmadas
          visible={this.state.modalUbicacionesConfirmadasVisible}
          onClose={() => this.setState({ modalUbicacionesConfirmadasVisible: false, modalUbicacionesConfirmadasOrdenId: null })}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          documentoOrigenId={this.state.modalUbicacionesConfirmadasOrdenId}
          documentoOrigenTipo="OrdenDeCompra"
        />
        <Modal
          title="Cancelar orden de compra"
          visible={this.state.modalCancelarOC}
          onCancel={() => this.cerrarModalCancelarOC()}
          footer={[
            <ButtonItem key="no-regresar" onClick={() => this.cancelarOrdenDeCompra(this.state.modalCancelarOCId, false)}>
              No regresar insumos
            </ButtonItem>,
            <ButtonItem key="regresar" verde onClick={() => this.cancelarOrdenDeCompra(this.state.modalCancelarOCId, true)}>
              Regresar insumos a la requisición
            </ButtonItem>,
          ]}
        >
          Se cancelará esta orden de compra. ¿Qué quieres hacer con los insumos en la requisición de origen?
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    autorizacionesRapidas: state.empresa.autorizacionesRapidas,
    permisoAgregarOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cbdcaf30e81b54183cf5e"
      )?.activado,
    permisoRecibirFacturaOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cc021f30e81b54183cf62"
      )?.activado,
    permisoRecibirInsumosOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cc05bf30e81b54183cf63"
      )?.activado,
    permisoCancelarOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d26e4b2da7c85c1a8cfd"
      )?.activado,
    permisoEditarOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69fc1052ffec9d357741829d"
      )?.activado,
    permisoAprobarOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a13c3f22a586012f040fe34"
      )?.activado,
    permisoListadoDePendientes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a6a296d024d2c4c1a14be1f"
      )?.activado,
    // Monto máximo que puede aprobar (null = sin tope, igual que master).
    montoMaximoAprobacion: montoMaximoPermiso(
      state.user.permisos,
      state.user.tipo,
      "6a1477c69016757478eb99d2"
    ),
    prorrateoDesCostos: state.empresa.prorrateoDesCostos,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(OrdenesDeCompras);
